import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selectedOrderNoteOptionsArray'
})
export class SelectedOrderNoteOptionsArrayPipe implements PipeTransform {
  transform(collection: Array<any>): string {
    if (collection && collection.length) {
      const orderNoteOptionPrefix = 'Adding: ';
      return `${orderNoteOptionPrefix}${collection
        .map((x) => x.text.trim())
        .join(', ')}`;
    }
  }
}
